module.exports = __webpack_public_path__ + "static/media/21ECLAC31.7a8bf0ce.jpg";